<script setup>
import { ref, onMounted, computed, inject, onUnmounted } from 'vue'

import LogoImg from '@/assets/img/logo.png'
import BannerImg from '@/assets/img/Banner.png'
import BannerBtnImg from '@/assets/img/BannerBtn.png'
import CardBgImg from '@/assets/img/card/bg.png'
import CardButtonImg from '@/assets/img/card/claimnow.png'
import ComingBtnImg from '@/assets/img/card/comingsoon.png'
import WithdrawalFrameImg from '@/assets/img/withdrawal-frame.png'
// 导入评论图片
import Review1 from '@/assets/img/review/1.png'
import Review2 from '@/assets/img/review/2.png'
import Review3 from '@/assets/img/review/3.png'
import Review4 from '@/assets/img/review/4.png'
import Review5 from '@/assets/img/review/5.png'
import Review6 from '@/assets/img/review/6.png'
import Review7 from '@/assets/img/review/7.png'
import Review8 from '@/assets/img/review/8.png'
// 导入页脚图片
import GamingLicenseImg from '@/assets/img/gaminglicense.png'
import CertImg from '@/assets/img/cert.png'



const apiBaseUrl = inject('apiBaseUrl')


// 创建评论数组
const reviewImages = [
    Review1, Review2, Review3, Review4,
    Review5, Review6, Review7, Review8
]

// 随机排序评论图片
const shuffledReviews = computed(() => {
    return [...reviewImages].sort(() => Math.random() - 0.5)
})

const partners = ref([])
const tglink = ref("")
const withdrawals = ref([])
let withdrawalInterval = null

const readJsonFile = async (filename) => {
    const response = await fetch(`${apiBaseUrl}/API/readJson.php`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({ jsonUrl: filename })
    })
    const data = await response.json().catch(() => null)
    if (!response.ok) {
        throw new Error(data?.message || `读取 ${filename} 失败（HTTP ${response.status}）`)
    }
    if (!data || typeof data !== 'object') {
        throw new Error(`${filename} 返回格式错误`)
    }
    return data
}

// 走马灯文本
const marqueeText = "Welcome to FCS Group Partnertship! Try Our Slot Games Now! Live Casino, E-Spots Betting, Fishing Games Explore More Passive Income Opportunities At Our Company! Please Click \"MORE INFO\" for Details or Join Our Telegram Group get more detail."

// 格式化日期时间为相对时间
const formatRelativeTime = (dateTimeStr) => {
    const now = new Date()
    const date = new Date(dateTimeStr)
    const diffMs = now - date

    // 如果时间是未来时间，显示具体时间
    if (diffMs < 0) {
        const options = { hour: '2-digit', minute: '2-digit', second: '2-digit' }
        return date.toLocaleTimeString(undefined, options)
    }

    // 转换为分钟
    const diffMins = Math.floor(diffMs / 60000)

    if (diffMins < 1) return 'just now'
    if (diffMins < 60) return `${diffMins} min ago`

    const diffHours = Math.floor(diffMins / 60)
    if (diffHours < 24) return `${diffHours} hours ago`

    const diffDays = Math.floor(diffHours / 24)
    return `${diffDays} days ago`
}

// 获取提款记录
const fetchWithdrawals = async () => {
    try {
        const response = await fetch(`${apiBaseUrl}/API/as6868/getAllTransactions.php`, { cache: 'no-store' })
        const data = await response.json().catch(() => null)
        if (!response.ok) {
            throw new Error(`提款记录 API 返回 HTTP ${response.status}`)
        }
        if (!Array.isArray(data)) {
            throw new Error('提款记录格式错误')
        }

        // 处理数据，添加格式化的时间
        withdrawals.value = data.map(item => ({
            ...item,
            formattedTime: formatRelativeTime(item.datetime),
            // 格式化金额，添加 + 号和保留两位小数
            formattedCash: `+$${parseFloat(item.cash).toFixed(2)}`
        }))
    } catch (error) {
        console.error('获取提款记录失败:', error)
    }
}

// 计算每个合作伙伴的倒计时
const getCountdown = (comingTime) => {
    // 如果 comingTime 是字符串 "true"，直接返回不可用状态，但不显示倒计时
    if (comingTime === "true") {
        return { isAvailable: false, countdown: '', showCountdown: false }
    }

    // 如果没有 comingTime 或为空，返回可用状态
    if (!comingTime) return { isAvailable: true, countdown: '', showCountdown: false }

    // 获取当前时间
    const now = new Date()

    // 将目标时间解析为 UTC 时间
    // 假设 comingTime 格式为 "YYYY/MM/DD HH:MM:SS" 或 "YYYY/M/D HH:MM:SS"
    const [datePart, timePart] = comingTime.split(' ')
    const [year, month, day] = datePart.split('/')
    const [hours, minutes, seconds] = timePart ? timePart.split(':') : ['00', '00', '00']

    // 创建目标日期对象 (月份需要减1，因为 JavaScript 月份从0开始)
    const targetDate = new Date(
        parseInt(year),
        parseInt(month) - 1,
        parseInt(day),
        parseInt(hours),
        parseInt(minutes),
        parseInt(seconds)
    )

    // 如果目标日期已过，返回可用状态
    if (now >= targetDate) {
        return { isAvailable: true, countdown: '', showCountdown: false }
    }

    // 计算剩余时间（毫秒）
    const diffTime = targetDate.getTime() - now.getTime()

    // 转换为天、小时、分钟、秒
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))
    const diffHours = Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const diffMinutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60))
    const diffSeconds = Math.floor((diffTime % (1000 * 60)) / 1000)

    // 格式化倒计时字符串
    let countdown = ''
    if (diffDays > 0) {
        countdown = `${diffDays}d ${diffHours}h ${diffMinutes}m`
    } else if (diffHours > 0) {
        countdown = `${diffHours}h ${diffMinutes}m ${diffSeconds}s`
    } else {
        countdown = `${diffMinutes}m ${diffSeconds}s`
    }

    return { isAvailable: false, countdown, targetDate, showCountdown: true }
}

// 更新所有倒计时
const updateAllCountdowns = () => {
    let needsInterval = false;

    partners.value.forEach(partner => {
        // 如果已经确定可用，跳过计算
        if (partner.isAvailable) return;

        if (partner.ComingTime) {
            // 如果有目标日期，计算倒计时
            const result = getCountdown(partner.ComingTime)
            partner.isAvailable = result.isAvailable
            partner.showCountdown = result.showCountdown

            if (!partner.isAvailable) {
                // 只有当还有未到期的合作伙伴时，才需要继续更新
                // 并且只有当需要显示倒计时时，才需要定时器
                if (result.showCountdown) {
                    needsInterval = true;
                    partner.countdown = result.countdown
                    partner.targetDate = result.targetDate
                }
            }
        } else {
            partner.isAvailable = true
            partner.countdown = ''
            partner.showCountdown = false
        }
    })

    return needsInterval;
}

const loadTgBanner = async () => {
    try {
        const tgbanner = await readJsonFile('tgbanner.json')
        tglink.value = typeof tgbanner.link === 'string' ? tgbanner.link : ''
    } catch (error) {
        console.error('获取 Telegram 链接失败:', error)
    }
}

const loadPartners = async () => {
    try {
        const data = await readJsonFile('partners.json')
        if (!Array.isArray(data.partners)) {
            throw new Error('partners.json 缺少 partners 数组')
        }
        partners.value = data.partners
    } catch (error) {
        partners.value = []
        console.error('获取合作伙伴数据失败:', error)
    }
}

// 从 API 获取数据；各区块独立加载，避免单一请求失败拖垮整页
onMounted(async () => {
    await Promise.all([loadTgBanner(), loadPartners()])

    // 初始化倒计时
    const needsInterval = updateAllCountdowns()

    // 只有当有未到期的合作伙伴时，才设置定时器
    if (needsInterval) {
        const intervalId = setInterval(() => {
            // 每次更新后检查是否还需要继续更新
            const stillNeedsInterval = updateAllCountdowns()
            if (!stillNeedsInterval) {
                // 如果所有合作伙伴都已可用，清除定时器
                clearInterval(intervalId)
                console.log('所有倒计时已完成，停止更新')
            }
        }, 1000)
    }

    // 获取提款记录
    await fetchWithdrawals()

    // 设置定时刷新提款记录 (每10秒刷新一次，从30秒改为10秒)
    withdrawalInterval = setInterval(fetchWithdrawals, 10000)

    // 初始化 Swiper
    initSwiper()
})

// 组件卸载时清除定时器
onUnmounted(() => {
    if (withdrawalInterval) {
        clearInterval(withdrawalInterval)
    }
})

// 初始化 Swiper
const initSwiper = () => {
    // 使用动态导入避免 SSR 问题
    import('swiper/bundle').then(({ Swiper }) => {
        import('swiper/css/bundle').then(() => {
            new Swiper('.swiper-container', {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                autoplay: {
                    delay: 5000,  // 增加显示时间
                    disableOnInteraction: false,
                },
                effect: 'fade',  // 使用淡入淡出效果
                fadeEffect: {
                    crossFade: true
                },
                // 添加导航按钮
                navigation: {
                    nextEl: '.review-arrow-right',
                    prevEl: '.review-arrow-left',
                },
                // 可选：添加分页器
                pagination: {
                    el: '.review-dots',
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<span class="' + className + ' review-dot"></span>';
                    },
                }
            })
        })
    })
}

const currentSlide = ref(0)
const totalSlides = ref(5) // 假设有5张幻灯片，根据实际情况调整
const autoplayInterval = ref(null)
const autoplayDelay = 5000 // 5秒自动切换一次

// 切换到下一张幻灯片
const nextSlide = () => {
    currentSlide.value = (currentSlide.value + 1) % totalSlides.value
    resetAutoplay()
}

// 切换到上一张幻灯片
const prevSlide = () => {
    currentSlide.value = (currentSlide.value - 1 + totalSlides.value) % totalSlides.value
    resetAutoplay()
}

// 直接跳转到指定幻灯片
const goToSlide = (index) => {
    currentSlide.value = index
    resetAutoplay()
}

// 重置自动播放计时器
const resetAutoplay = () => {
    if (autoplayInterval.value) {
        clearInterval(autoplayInterval.value)
    }
    autoplayInterval.value = setInterval(nextSlide, autoplayDelay)
}

// 组件挂载时启动自动播放
onMounted(() => {
    resetAutoplay()

    // 添加键盘左右箭头监听
    window.addEventListener('keydown', handleKeyDown)
})

// 组件卸载时清除自动播放
onUnmounted(() => {
    if (autoplayInterval.value) {
        clearInterval(autoplayInterval.value)
    }

    // 移除键盘监听
    window.removeEventListener('keydown', handleKeyDown)
})

// 处理键盘左右箭头
const handleKeyDown = (event) => {
    if (event.key === 'ArrowLeft') {
        prevSlide()
    } else if (event.key === 'ArrowRight') {
        nextSlide()
    }
}


// 在现有代码中添加以下内容
const currentReviewIndex = ref(0)
const reviewsPerView = 1 // 一次显示几个评论
const totalReviews = computed(() => reviewImages.length)

// 切换到下一个评论
const nextReview = () => {
    currentReviewIndex.value = (currentReviewIndex.value + 1) % totalReviews.value
}

// 切换到上一个评论
const prevReview = () => {
    currentReviewIndex.value = (currentReviewIndex.value - 1 + totalReviews.value) % totalReviews.value
}

// 直接跳转到指定评论
const goToReview = (index) => {
    currentReviewIndex.value = index
}

// 自动轮播评论
let reviewInterval = null
const startReviewAutoplay = () => {
    reviewInterval = setInterval(() => {
        nextReview()
    }, 3000) // 每3秒切换一次
}

onMounted(() => {
    // 启动评论自动轮播
    startReviewAutoplay()
})

onUnmounted(() => {
    // 清除评论轮播定时器
    if (reviewInterval) {
        clearInterval(reviewInterval)
    }
})
</script>

<template>

    <div class="container">
        <header class="header">
            <img :src="LogoImg" alt="Fair Dinkum Pokies" class="main-logo">
        </header>

        <!-- 走马灯 -->
        <div class="marquee-container">
            <div class="marquee-content">
                <span>{{ marqueeText }}</span>
                <span>{{ marqueeText }}</span>
            </div>
        </div>

        <!-- Banner 和按钮 -->
        <div class="banner-container">
            <img :src="BannerImg" alt="Partnership Banner" class="banner-img">
            <a :href="tglink" target="_blank" rel="noopener noreferrer">
                <img :src="BannerBtnImg" alt="More Info" class="banner-btn bounce-animation">
            </a>
        </div>

        <div class="sites-grid">
            <div v-for="partner in partners" :key="partner.name" class="site-card">
                <div class="card-bg" :style="{ backgroundImage: `url(${CardBgImg})` }">
                    <div class="card-content">
                        <div v-if="partner.tagTop || partner.tagDown" class="top-partner-badge"
                            :style="{ '--tag-color': partner.tagColor }">
                            <span>{{ partner.tagTop }}</span>
                            <span>{{ partner.tagDown }}</span>
                        </div>
                        <img :src="partner.logo" :alt="partner.name" class="site-logo">

                        <div class="bonus-section">

                            <!-- TOP PARTNER角标 - 只在top为true时显示 -->


                            <div v-for="(item, index) in partner.items.slice(0)" :key="index" class="bonus-row">
                                <span class="bonus-label">{{ item.label }}</span>
                                <span class="bonus-value highlight">{{ item.value }}</span>
                            </div>
                        </div>

                        <!-- 倒计时显示 - 只在需要显示倒计时时显示 -->
                        <div v-if="!partner.isAvailable && partner.showCountdown" class="countdown-timer">
                            <span>COMING SOON</span>
                            <span class="countdown-value">{{ partner.countdown }}</span>
                        </div>

                        <a v-if="partner.isAvailable" target="_blank" :href="partner.link"
                            class="claim-btn-container bounce-animation">
                            <img :src="CardButtonImg" alt="Claim Now" class="claim-btn-img">
                        </a>
                        <div v-else class="claim-btn-container disabled bounce-animation">
                            <img :src="ComingBtnImg" alt="Coming Soon" class="claim-btn-img">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 提款记录部分 -->
        <div class="withdrawals-section" :style="{ backgroundImage: `url(${WithdrawalFrameImg})` }">
            <h2>
                <span>PARTNER WITHDRAWALS</span>
                <span class="live-indicator">LIVE</span>
            </h2>
            <div class="withdrawals-container">
                <div v-for="(withdrawal, index) in withdrawals" :key="index" class="withdrawal-item">
                    <div class="withdrawal-logo">
                        <img :src="withdrawal.source" alt="Partner Logo" class="withdrawal-logo-img">
                    </div>
                    <div class="withdrawal-info">
                        <div class="withdrawal-mobile">{{ withdrawal.mobile }}</div>
                    </div>
                    <div class="withdrawal-info2">
                        <div class="withdrawal-amount">{{ withdrawal.formattedCash }}</div>
                        <div class="withdrawal-time">{{ withdrawal.datetime }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 评论轮播 -->
        <div class="reviews-section">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div v-for="(review, index) in shuffledReviews" :key="index" class="swiper-slide">
                        <img :src="review" :alt="`Player Review ${index + 1}`" class="review-image">
                    </div>
                </div>

                <!-- 添加左右箭头导航 -->
                <div class="review-arrows">
                    <button class="review-arrow review-arrow-left">
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 19L8 12L15 5" stroke="#FFD700" stroke-width="3" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </button>
                    <button class="review-arrow review-arrow-right">
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 5L16 12L9 19" stroke="#FFD700" stroke-width="3" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>

                <!-- 添加分页器 -->
                <div class="review-dots"></div>
            </div>
        </div>

        <!-- 页脚部分 -->
        <footer class="footer">
            <div class="footer-section">
                <h3>GAMING LICENCES</h3>
                <div class="footer-img-container">
                    <img :src="GamingLicenseImg" alt="Gaming Licenses" class="footer-img1">
                </div>
            </div>

            <div class="footer-section">
                <h3>CERTIFICATIONS</h3>
                <div class="footer-img-container">
                    <img :src="CertImg" alt="Certifications" class="footer-img">
                </div>
            </div>
        </footer>

    </div>
</template>

<style scoped>
/* 提款记录样式 */
.withdrawals-section {
    margin: 2rem 0;
    padding: 1.5rem;
    border-radius: 10px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    margin-left: auto;
    margin-right: auto;
}

.withdrawals-section h2 {
    color: #ffd700;
    margin-bottom: 1.5rem;
    font-size: 1.5rem;
    text-shadow: 0 0 10px rgba(255, 215, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    letter-spacing: 1px;
    padding: 0 0.5rem;
}

.live-indicator {
    background-color: #ff0000;
    color: white;
    font-size: 0.7rem;
    padding: 0.2rem 0.5rem;
    border-radius: 4px;
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.5;
    }

    100% {
        opacity: 1;
    }
}

.withdrawals-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    /* max-height: 400px; */
}

.withdrawals-container::-webkit-scrollbar {
    width: 3px;
}

.withdrawals-container::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 10px;
}

.withdrawals-container::-webkit-scrollbar-thumb {
    background: rgba(255, 215, 0, 0.5);
    border-radius: 10px;
}

.withdrawal-item {
    display: flex;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 0.6rem 0.8rem;
    border-radius: 8px;
    transition: all 0.3s ease;
    margin-bottom: 0.3rem;
}

.withdrawal-logo {
    width: 120px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-right: 10px;
}

.withdrawal-logo-img {
    width: 100%;
    height: auto;
    object-fit: contain;
    max-height: 70px;
}

.withdrawal-info {
    flex: 1;
    text-align: center;
}

.withdrawal-info2 {
    min-width: 120px;
    text-align: right;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.withdrawal-mobile {
    font-size: 1rem;
    color: white;
}

.withdrawal-time {
    font-size: 0.7rem;
    color: #aaa;
    margin-top: 0.2rem;
}

.withdrawal-amount {
    font-size: 1.1rem;
    font-weight: bold;
    color: #4caf50;
    margin-bottom: 0.2rem;
}

/* 响应式调整 */
@media (max-width: 768px) {
    .withdrawals-section {
        padding: 1rem;
    }

    .withdrawals-section h2 {
        font-size: 1.3rem;
    }

    .withdrawal-item {
        padding: 0.5rem 0.7rem;
    }

    .withdrawal-logo {
        width: 100px;
        height: 45px;
    }

    .withdrawal-logo-img {
        max-height: 60px;
    }

    .withdrawal-info2 {
        min-width: 100px;
    }

    .withdrawal-mobile {
        font-size: 0.85rem;
    }

    .withdrawal-time {
        font-size: 0.65rem;
    }

    .withdrawal-amount {
        font-size: 1rem;
    }
}

@media (max-width: 480px) {
    .withdrawals-section h2 {
        font-size: 1.2rem;
    }

    .live-indicator {
        font-size: 0.65rem;
        padding: 0.1rem 0.3rem;
    }

    .withdrawal-logo {
        width: 90px;
        height: 40px;
    }

    .withdrawal-logo-img {
        max-height: 50px;
    }

    .withdrawal-info {
        padding: 0 0.3rem;
    }

    .withdrawal-info2 {
        min-width: 90px;
    }

    .withdrawal-mobile {
        font-size: 0.8rem;
    }

    .withdrawal-time {
        font-size: 0.6rem;
    }

    .withdrawal-amount {
        font-size: 0.9rem;
    }
}

/* 修改卡片内容布局样式 */
.free-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.3rem 0;
    margin-bottom: 0.3rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    flex-wrap: wrap;
    /* 允许内容换行 */
}

.free-label {
    color: #f5f5dc;
    font-size: 1.4rem;
    font-weight: bold;
    text-shadow: 0 0 5px rgba(255, 255, 255, 0.7);
    letter-spacing: 1px;
    font-style: italic;
    text-align: left;
    font-family: Arial, sans-serif;
    min-width: 80px;
    /* 确保最小宽度 */
    margin-right: 5px;
    /* 添加右侧间距 */
}

.free-value {
    color: #ffd700;
    font-size: 1.4rem;
    font-weight: bold;
    text-shadow: 0 0 8px rgba(255, 215, 0, 0.6), 0 0 15px rgba(255, 215, 0, 0.4);
    text-align: right;
    flex: 1;
    /* 允许伸缩 */
}

.bonus-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    /* 改为顶部对齐 */
    padding: 0.2rem 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
    flex-wrap: wrap;
    /* 允许内容换行 */
    min-height: 2.2rem;
    /* 设置最小高度 */
}

.bonus-label {
    color: #e0e0e0;
    font-size: 0.8rem;
    text-align: left;
    font-style: italic;
    font-family: Arial, sans-serif;
    opacity: 0.9;
    width: 45%;
    /* 固定宽度 */
    padding-right: 5px;
    /* 添加右侧间距 */
}

.bonus-value {
    color: #ffd700;
    font-weight: bold;
    font-size: 1.1rem;
    text-align: right;
    text-shadow: 0 0 5px rgba(255, 215, 0, 0.4);
    width: 50%;
    /* 固定宽度 */
}

.bonus-value.highlight {
    font-size: 1rem;
    text-shadow: 0 0 8px rgba(255, 215, 0, 0.6), 0 0 15px rgba(255, 215, 0, 0.4);
}

/* 响应式调整 */
@media (max-width: 480px) {
    .free-label {
        font-size: 1rem;
        min-width: 70px;
    }

    .free-value {
        font-size: 1rem;
    }

    .bonus-label {
        font-size: 0.7rem;
        width: 45%;
    }

    .bonus-value {
        font-size: 0.9rem;
        width: 50%;
    }

    .bonus-value.highlight {
        font-size: 0.7rem;
    }
}

/* 更小的屏幕 */
@media (max-width: 360px) {
    .free-label {
        font-size: 1rem;
        min-width: 60px;
    }

    .free-value {
        font-size: 1rem;
    }

    .bonus-label {
        font-size: 0.65rem;
        width: 45%;
    }

    .bonus-value {
        font-size: 0.8rem;
        width: 50%;
    }

    .bonus-value.highlight {
        font-size: 1rem;
    }
}

/* 箭头导航样式 */
.review-arrows {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 10;
}

.review-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    pointer-events: auto;
    padding: 10px;
}

.review-arrow-left {
    left: 0;
}

.review-arrow-right {
    right: 0;
}

.review-arrow svg {
    filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.7));
    transition: all 0.3s ease;
}

.review-arrow:hover svg {
    transform: scale(1.2);
    filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.9)) drop-shadow(0 0 5px rgba(255, 215, 0, 0.8));
}

.review-arrow:active svg {
    transform: scale(0.9);
}

/* 响应式样式 */
@media (max-width: 768px) {
    .review-arrow svg {
        width: 25px;
        height: 25px;
    }
}

@media (max-width: 480px) {
    .review-arrow svg {
        width: 20px;
        height: 20px;
    }
}

/* 评论轮播样式 */
.reviews-section {
    position: relative;
    margin: 2rem 0;
}

.swiper-container {
    position: relative;
    overflow: hidden;
    width: 100%;
}

.swiper-wrapper {
    display: flex;
    transition: transform 0.5s ease;
    transform: translateX(calc(-100% * var(--current-review-index, 0)));
}

.swiper-slide {
    flex: 0 0 100%;
    padding: 0 10px;
}

.review-image {
    width: 100%;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* 评论箭头导航样式 - 美化版 */
.review-arrows {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 10;
}

.review-arrow {
    position: absolute;
    top: 60%;
    transform: translateY(-50%);
    width: 50px;
    height: 50px;
    /* background: linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 100%); */
    /* border: 1px solid rgba(255, 215, 0, 0.7); */
    /* border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    pointer-events: auto;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3); */
}

.arrow-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    transition: all 0.3s ease;
}

/* .review-arrow:hover {
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.6) 100%);
    border-color: #FFD700;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4), 0 0 15px rgba(255, 215, 0, 0.3);
    transform: translateY(-50%) scale(1.05);
} */

/* .review-arrow:active {
    transform: translateY(-50%) scale(0.95);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
} */

.review-arrow-left {
    left: 0;
}

.review-arrow-right {
    right: 0;
}

/* .review-arrow svg {
    width: 24px;
    height: 24px;
    filter: drop-shadow(0 0 3px rgba(255, 215, 0, 0.5));
    transition: all 0.3s ease;
}

.review-arrow:hover svg {
    transform: scale(1.1);
    filter: drop-shadow(0 0 5px rgba(255, 215, 0, 0.8));
} */

/* 响应式样式 */
@media (max-width: 768px) {
    .review-arrow {
        width: 40px;
        height: 40px;
    }

    .review-arrow svg {
        width: 20px;
        height: 20px;
    }
}

@media (max-width: 480px) {
    .review-arrow {
        width: 36px;
        height: 36px;
    }

    .review-arrow svg {
        width: 18px;
        height: 18px;
    }

    .review-arrow-left {
        left: 0;
    }

    .review-arrow-right {
        right: 0;
    }
}

/* 评论导航点样式 */
.review-dots {
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
    z-index: 10;
}

.review-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: rgba(255, 215, 0, 0.3);
    cursor: pointer;
    transition: background-color 0.3s;
}

.review-dot.active {
    background-color: rgba(255, 215, 0, 0.8);
}

/* 响应式样式 */
@media (max-width: 768px) {
    .review-arrow {
        width: 40px;
        height: 40px;
    }

    .review-arrow svg {
        width: 20px;
        height: 20px;
    }
}

@media (max-width: 480px) {
    .review-arrow {
        width: 36px;
        height: 36px;
    }

    .review-arrow svg {
        width: 18px;
        height: 18px;
    }

    .review-arrow-left {
        left: 0;
    }

    .review-arrow-right {
        right: 0;
    }
}

/* 添加跳动动画样式 */
.bounce-animation {
    animation: bounce 0.5s ease infinite;
    transform-origin: center bottom;
}

@keyframes bounce {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-5px);
    }
}

/* 当鼠标悬停时稍微放大按钮 */
.banner-btn:hover {
    transform: scale(1.05);
    transition: transform 0.3s ease;
}

/* 确保按钮可以正常显示动画 */
.banner-btn {
    cursor: pointer;
    transition: transform 0.3s ease;
}

/* Top Partner 角标 */
/* Top Partner 角标 */
.top-partner-badge {
    position: absolute;
    /* top: -3%;
    left: 0; */
    background: var(--tag-color, #ff6b00);
    color: #000;
    padding: 5px 0;
    width: 120px;
    font-size: 0.7rem;
    font-weight: 700;
    text-align: center;
    transform: rotate(-45deg) translateX(-30px) translateY(-35px);
    box-shadow: 0 2px 10px rgba(255, 107, 0, 0.3);
    z-index: 3;
    display: flex;
    flex-direction: column;
    line-height: 1;
}

.top-partner-badge span:first-child {
    font-size: 1.2em;
    font-weight: bold;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.top-partner-badge span:last-child {
    font-size: 0.9em;
    opacity: 0.9;
}

@media (max-width: 768px) {

    .top-partner-badge {
        transform: rotate(-45deg) translateX(-20px) translateY(-30px);
        width: 90px;
        font-size: 0.55rem;
    }
}

@media (max-width: 480px) {

    .top-partner-badge {
        transform: rotate(-45deg) translateX(-20px) translateY(-30px);
        width: 90px;
        font-size: 0.55rem;
    }
}
</style>
